export default {
    Active(state, val){state.access = val},
    set_asideStorage(state, val){ state.asideStorage = val; },
    ActiveLateral(state, val) { state.lateralShow = val; },
}
